
// Books that have a substantial amount of poetry (not just a stanza here and there)
// These are presented better with less indent since it applies to much of the book
export const substantial_poetry:readonly string[] = Object.freeze([
    'job',  // Job
    'psa',  // Psalms
    'pro',  // Proverbs
    'ecc',  // Ecclesiastes
    'sng',  // Song of Songs
    'isa',  // Isaiah
    'jer',  // Jeremiah
    'lam',  // Lamentations
    'ezk',  // Ezekiel
    // 'dan',  Daniel       (some stanzas but still part of the narrative)
    'hos',  // Hosea
    'jol',  // Joel
    'amo',  // Amos
    'oba',  // Obadiah
    // 'jon',  Jonah        (just one prayer)
    'mic',  // Micah
    'nam',  // Nahum
    'hab',  // Habakkuk
    'zep',  // Zephaniah
    'hag',  // Haggai
    'zec',  // Zechariah
    // 'mal',  Malachi      (dialogue, not stanzas)
])
